/**
 * Shared constants for action text used in layer management components
 */
export const ACTION_TEXT = {
  MANAGE_SELECTED_ITEMS: "Manage Selected Items",
  EXIT_MANAGE_MODE: "Exit Manage Mode",
  CLEAR_SELECTED_ITEMS: "Deselect All Items",
  DELETE_SELECTED_ITEMS: "Delete Selected Items",
  REMOVE_SELECTED_ITEMS: "Remove Selected Items"
} as const;
